import { getLogger } from '../logging/logger';

const logger = getLogger('mTheory');

class MTheory {
	initialize() {
		logger.log('[initialized]');

		if (this.isMTheory() && window.nz) {
			document.body.classList.add('mTheory');
			window.nz.nzappapi.Initialize('https://jsapi.M-theory.net/prod/nzappapi.proto', {});
			this.appVisible();
		} else {
			logger.info('MTheory not detected');
		}
	}

	appVisible() {
		// console.log(CN,'[appVisible]');

		if (this.isMTheory() && window.nz) {
			console.debug('MTheory app visible');
			window.nz.nzappapi.AppVisible();
		}
	}

	appShutdown() {
		logger.log('[appShutdown]');

		if (this.isMTheory() && window.nz) {
			console.info('Sending MTheory shutdown');
			window.nz.nzappapi.AppShutdown();
		}
	}

	isMTheory() {
		return /M-Theory-Chromium/.test(navigator.userAgent);
	}
}

export default new MTheory();
